import React from 'react';
import { green } from '../../Utils/styleConstants';
import { getInTarifsState } from '../../Utils/storeHelpers';
import TarifRecapOption from "./TarifRecapOptions";


const PackGestionLocativeRecap = () => {
    const valueDisplay = getInTarifsState('pack-gestion-locative-value-display');
    const offer = getInTarifsState('pack-gestion-locative-offer');
    const offerAdditionalUser = getInTarifsState('pack-gestion-locative-additional-users');

    const rows = [
        {
            label: 'Sous-Total',
            prices: [
                {
                    value: valueDisplay.price,
                    unit: `HT ${valueDisplay.priceUnit}`,
                },
            ],
        },
        {
            label: 'Offre PACK GESTION LOCATIVE',
            subLabels: [
                'Utilisateur(s) supplémentaire(s)',
                'Frais de mise en service',
            ],
            backgroundColor: green,
            color: 'black',
            fontSize: '25px',
            prices: [
                {
                    value: offer.price,
                    color: 'white',
                    unit: `HT ${offer.priceUnit}`,
                },
                {
                    value: offerAdditionalUser.price,
                    color: 'white',
                    unit: `HT ${offerAdditionalUser.priceUnit}`,
                    small: true,
                },
                {
                    value: 350,
                    color: 'white',
                    unit: 'HT',
                    small: true,
                },
            ],
        },
    ];

    return <TarifRecapOption rows={rows} />;
};

export default PackGestionLocativeRecap;